import router from '../../src/router';
import store from '../../src/store';
import { i18n } from '../../src/plugins/i18n';
import NotificationEmitter from '../../src/components/NotificationEmitter.vue';

export default {
  components: {
    NotificationEmitter,
  },
  router,
  store,
  i18n,
};
